import { IGetPatrimonioMaquinaEquipByIdUseCase } from "../../../presentation/useCases/read/get_patrimonio_maquina_equip_by_id_use_case";
import { PatrimonioMaquinaEquipModel } from "../../models/patrimonio_maquina_equip";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetPatrimonioMaquinaEquipByIdUseCase
 */

export class GetPatrimonioMaquinaEquipByIdUseCase implements IGetPatrimonioMaquinaEquipByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getPatrimonioMaquinaEquipById(
    idPatrimonioMaquinaEquip: number,
  ): Promise<PatrimonioMaquinaEquipModel> {
    return await this.repository.getPatrimonioMaquinaEquipById(
      idPatrimonioMaquinaEquip
    );
  }
}
